// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";

export const counterSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
  },
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { setUser } = counterSlice.actions;

export default counterSlice.reducer;

export const getUser = (state) => state.user.user;
